import agregarEmp from "../../../assets/pepper-icons/sidebar/16_Icono_Agregar empresa.svg";
import iconEquis from "../../../assets/pepper-icons/rightbar/icon_equis.svg";
import iconDescarga from "../../../assets/pepper-icons/rightbar/icon_descarga.svg";
import iconComp from "../../../assets/pepper-icons/rightbar/comp.svg";
import iconArchivo from "../../../assets/pepper-icons/rightbar/icon_archivo.svg";
import iconInternet from "../../../assets/pepper-icons/rightbar/icon_internet.svg";
import iconAgregar from "../../../assets/pepper-icons/rightbar/icon_agregar.svg";
import iconAgregar2 from "../../../assets/pepper-icons/rightbar/pepper-17.svg";
import iconCuentas from "../../../assets/pepper-icons/rightbar/icon_cuentas.svg";
import iconImagenes from "../../../assets/pepper-icons/rightbar/icon_imagenes.svg";
import iconImagenes1 from "../../../assets/pepper-icons/rightbar/icon_imagenes_1.svg";
import iconLupa from "../../../assets/pepper-icons/rightbar/icon_lupa.svg";
import iconSubir from "../../../assets/pepper-icons/rightbar/icon_subir.svg";
import iconPDF from "../../../assets/pepper-icons/rightbar/icon_PDF.svg";
import iconPag from "../../../assets/pepper-icons/rightbar/icon_pag.svg";
import iconEstrella from "../../../assets/pepper-icons/rightbar/icon_estrella.svg";
import ReIncludeProvider from "./formTypes/reIncludeProvider";
import NewAgenda from "./formTypes/newAgenda";
import EditAgenda from "./formTypes/editAgenda";
import ImportProvider from "./formTypes/importProvider";
import InformProvider from "./formTypes/informProvider";
import filterIcon from "../../../assets/icons/proveedores/Icon_Filtro.svg";
import addPersonaIcon from "../../../assets/icons/proveedores/Icon_persona agregar.svg";
import megafonoIcon from "../../../assets/icons/proveedores/Icon_megafono.svg";
import editarIcon from "../../../assets/icons/proveedores/Icon_editar.svg";
import subidaIcon from "../../../assets/icons/proveedores/Icon_subida.svg";
import descargaIcon from "../../../assets/icons/proveedores/Icon_descarga.svg";
import iconPayOff from "../../../assets/pepper-icons/rightbar/iconPayOff.svg";
import iconRevertPayOff from "../../../assets/pepper-icons/rightbar/iconRevertPayOff.svg";
import updateIcon from "../../../assets/pepper-icons/rightbar/icon_update.svg";

import Plus from "../../../assets/svg/svg_icons/plus.svg";
import Edit_Area from "../../../assets/svg/svg_icons/edit_area.svg";
import Filter from "../../../assets/svg/svg_icons/filter.svg";
import Import from "../../../assets/svg/svg_icons/import.svg";
import Export from "../../../assets/svg/svg_icons/export.svg";
import Clasificar from "../../../assets/svg/svg_icons/classify.svg";
import ExcludeProvider from "../../../assets/svg/svg_icons/excludeProvider.svg";
import Refresh from "../../../assets/svg/svg_icons/refresh.svg";
import Bank from "../../../assets/svg/svg_icons/bank.svg";
import creditCard from 'src/assets/svg/svg_icons/creditCard.svg';
import iconComment from 'src/assets/svg/svg_icons/comment.svg';
import { FULL_ACCESS_PLANS, Plans } from "src/utils/plans";
import CrearObligacion from "./forms/crearObligacion";

export const getIconsByPage = (page, company) => {
  const companyPlans = company?.plan || [];

  let pageIcon = [];
  switch (page) {
    case "flujocaja":
      pageIcon = [
        { item: "iconAgregar", msgKey: "tooltips.flujocaja.iconAgregar", icon: Plus },
        { item: "editarIcon", msgKey: "tooltips.flujocaja.editarIcon", icon: Edit_Area },
        { item: "initialBalance", msgKey: "tooltips.flujocaja.initialBalance", icon: Bank },
        { item: "importObligations", msgKey: "tooltips.flujocaja.importObligations", icon: Import },
        { item: "exportCashFlow", msgKey: "tooltips.flujocaja.exportCashFlow", icon: Export },
        { item: "addCredit", msgKey: "tooltips.flujocaja.addCredit", icon: creditCard },
        { item: "flowComments", msgKey: "tooltips.flujocaja.flowComments", icon: iconComment },
        {
          item: "bitacora",
          msgKey: "tooltips.flujocaja.bitacora",
          icon: iconComp,
          iconComponent: "compass",
        },
      ];
      break;
    /*
      Los dos reportes de gestión (EERR y balance clasificado): un solo icono,
      el panel de comentarios del reporte. Comparten caso porque comparten
      pantalla, tabla y panel; solo cambia qué reporte se le pasa por `options`.
    */
    case "reportesGestion":
      pageIcon = [
        { item: "reportComments", msg: "Comentarios", icon: iconComment },
        { item: "unassignedAccounts", msg: "Asignar cuentas contables", icon: Clasificar },
      ];
      break;
    case "documentostributarios": {
      pageIcon = [
        // {
        //   item: "filterIcon", // Filtro antiguo - reemplazado por DocumentFilters en TablaDocumentos.jsx y DinTable.jsx
        //   msg: "Filtrar",
        //   icon: Filter,
        // },
        /*         {
          item: "editarIcon",
          msg: "Editar áreas",
          icon: iconPag,
        }, */

        // {
        //   item: "iconDescarga",
        //   msg: "Descargar Archivo Masivo",
        //   icon: Export,
        //   showModal: true,
        // },
        {
          item: "iconDescarga2",
          msgKey: "tooltips.bulkDownload",
          msgNs: "documents",
          icon: Export,
        },
        // {
        //   item: "updateIcon",
        //   msg: "Actualizar",
        //   icon: Refresh,
        // },
        /*         {
          item: "iconPayOff",
          msg: "Saldar documentos",
          icon: iconPayOff,
        }, */
        /*         {
          item: "iconRevertPayOff",
          msg: "Devolver al saldo inicial",
          icon: iconRevertPayOff,
        }, */
        {
          item: "importObligations",
          msgKey: "tooltips.importObligations",
          msgNs: "documents",
          icon: Import,
        },
      ]

      // Clasificar oculto en documentos tributarios (ver commit 85ebc2d0).
    }
      break;
    case "proveedores":
      pageIcon = [
        {
          item: "importObligations",
          msgKey: "tooltips.flujocaja.importObligations",
          icon: Import,
        },
      ];
      break;
    case "creditos":
      pageIcon = [
        { item: "iconAgregar", msgKey: "tooltips.creditos.iconAgregar", icon: Plus },
      ];
      break;
    case "conexiones":
      pageIcon = [
        {
          item: "iconAgregar",
          msg: "Crear Conexión",
          icon: Plus,
        },
      ];
      break;
    case "agenda":
      pageIcon = [
        {
          item: "iconAgregar",
          msgKey: "tooltips.createContact",
          msgNs: "agenda",
          icon: Plus,
        },
        {
          item: "subidaIcon",
          msgKey: "tooltips.import",
          msgNs: "agenda",
          icon: Import,
        },
        {
          item: "iconDescarga",
          msgKey: "tooltips.export",
          msgNs: "agenda",
          icon: Export,
        },
      ];
      break;
    case "users":
      pageIcon = [
        {
          item: "iconAgregar",
          msg: "crear Usuario",
          icon: iconAgregar,
        },
      ];
      break;
    case "contratosProximosAVencer":
      pageIcon = [
        { item: "historyView", msg: "Ver historial", iconComponent: "clock" },
      ];
      break;
    case "haberesVariables":
      pageIcon = [
        { item: "hvComments", msgKey: "tooltips.haberesVariables.hvComments", icon: iconComment },
        { item: "hvDescarga", msgKey: "tooltips.haberesVariables.hvDescarga", icon: Export },
        { item: "hvSubida",   msgKey: "tooltips.haberesVariables.hvSubida",   icon: Import },
      ];
      break;
    case "conciliacion":
      pageIcon = [
        // {
        //   item: "filterIcon",
        //   msg: "Filtrar",
        //   icon: Filter,
        // },
        // {
        //   item: "updateIcon",
        //   msg: "Actualizar",
        //   icon: Refresh,
        // },
        {
          item: "subidaIcon",
          msgKey: "tooltips.conciliacion.import",
          icon: Import,
        },
        {
          item: "iconDescarga",
          msgKey: "tooltips.conciliacion.export",
          icon: Export,
        },
      ];
      break;
    case "eerr":
      pageIcon = [
        { item: "editar", msgKey: "tooltips.eerr.editar", icon: Edit_Area },
        { item: "exportEERR", msgKey: "tooltips.eerr.exportEERR", icon: Export },
      ];
      break;
    case "cobranza":
      pageIcon = [
        {
          item: "importObligations",
          msgKey: "tooltips.flujocaja.importObligations",
          icon: Import,
        },
      ];
      break;
    case "f29":
      pageIcon = [
        {
          item: "f29Comments",
          msg: "Comentarios",
          icon: iconComment,
        },
      ];
      break;
    case "eoaf":
      pageIcon = [
        { item: "clasificar", msgKey: "tooltips.eoaf.clasificar", icon: Edit_Area },
        { item: "eoafDownload", msgKey: "tooltips.eoaf.eoafDownload", icon: Export },
      ];
      break;
    case "cuadratura":
        pageIcon = [
          {
            item: "subidaIcon",
            msg: "Importar",
            icon: Import,
          },
        ];
        break;
    case "planDeCuentas":
      pageIcon = [
        {
          item: "importAccountChart",
          msg: "Importar Plan de Cuentas",
          icon: Import,
        },
      ];
      break;
    default:
  }
  return pageIcon;
};
